import { useSelector } from 'react-redux';
import { selectUserPermissions } from '@src/store/user/userSlice';
import {
    EffectivePermissions,
    PermissionRole,
} from '@src/services/users/myPermissions/myPermissionsApiSliceTypes';
import { RootState } from '@src/store/store';

export const usePermissions = () => {
    const { user, permissions } = useSelector((state: RootState) => ({
        user: state.user.user,
        permissions: selectUserPermissions(state),
    }));

    const isAuthenticated = !!user?.accessToken;

    const permissionOf = (
        module: keyof EffectivePermissions
    ): PermissionRole | undefined => {
        return permissions?.effective?.[module];
    };

    const allPermissions =
        permissions?.effective ?? ({} as EffectivePermissions);

    return { permissionOf, allPermissions, isAuthenticated };
};
